import { useEffect, useRef, useState } from "react";
import { Collapse, ListGroup } from "react-bootstrap";
import { usersOnboardingService } from "../../Services/usersOnboarding";
import { ImAddressBook } from "react-icons/im";
import LupReportingStudySidebar from "./LupReportingStudySidebar";

const StudySidebar = ({ studyId, handleAddNewTab, checkActiveTab, checkActiveDynamicTabData, collapseSidebar }) => {
  const [openForm, setOpenForm] = useState(false);
  const [openReport, setOpenReport] = useState(false);
  const [openStudy, setOpenStudy] = useState(false);
  const [openQuery, setOpenQuery] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [openSDV, setOpenSDV] = useState(false);
  const [openSettings, setOpenSettings] = useState(false);
  const [openDatasets, setOpenDatasets] = useState(false);
  const [studyLabel, setStudyLabel] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const findStudyLabel = async () => {
    let data = await usersOnboardingService.findStudyLabel(studyId);
    setStudyLabel(data?.data || "");
  };

  useEffect(() => {
    findStudyLabel();
  }, [studyId]);

  let studyDocumnetAccess = StudyMode === "DBP Mode" || studyPermission?.liveUploadDocument || studyPermission?.liveDownloadDocument || studyPermission?.liveDeleteDocument || studyPermission?.liveSDVUploadDocument || studyPermission?.liveSDVDownloadDocument || studyPermission?.liveSDVDeleteDocument || studyPermission?.qcUploadDocument || studyPermission?.qcDownloadDocument || studyPermission?.qcDeleteDocument || studyPermission?.qcSDVUploadDocument || studyPermission?.qcSDVDownloadDocument || studyPermission?.qcSDVDeleteDocument

  return (
    <div className="sidebar" id="myGroup">
      <div className="menus">
        <ListGroup className="w-100">
          <ListGroup.Item className={`border-0 border-bottom bg-light`} style={{ padding: "6px 0px 6px 15px" }}>
            <div className="hstack justify-content-between w-100">
              <span className="fw-bold hstack" style={{ height: 18 }}>
                <ImAddressBook className="me-1" />
                {!collapseSidebar && studyLabel}
              </span>
            </div>
          </ListGroup.Item>
          <ListGroup className="rounded-0 overflow-auto" style={{ height: "calc(100vh - 144px)" }}>
            <ListGroup.Item action
              className={`border-0 border-bottom ${openStudy && "bg-light"}`}
              style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
              onClick={() => setOpenStudy(!openStudy)}
            >
              <div className="hstack justify-content-between w-100">
                <span>
                  <i className={`fa-solid fa-${openStudy ? "folder-open" : "folder"} me-2`}></i>
                  {!collapseSidebar && <span>Study Management</span>}
                </span>
                <span>
                  <i className={`fa-solid fa-angle-${openStudy ? "down" : "right"}`}></i>
                </span>
              </div>
            </ListGroup.Item>
            <Collapse in={openStudy === true}>
              <div>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("studyDetail") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                  onClick={() => { handleAddNewTab("Study Details", "fa-solid fa-clipboard-list", "studyDetail") }}
                  title={"Study Details"}
                >
                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Study Details</span>}
                </ListGroup.Item>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("auditLogs") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                  onClick={() => { handleAddNewTab("Audit Logs", "fa-solid fa-clipboard-list", "auditLogs") }}
                  title={"Audit Logs"}
                >
                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Audit Logs</span>}
                </ListGroup.Item>
              </div>
            </Collapse>
            {(StudyMode === "DV Mode" || StudyMode === "DBP Mode") && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openForm && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenForm(!openForm)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openForm ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Form Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openForm ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openForm === true}>
                  <div>
                    {StudyMode === "DBP Mode" && (
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("formMetadata") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Form Metadata", "fa-solid fa-clipboard-list", "formMetadata") }}
                          title={"Form Metadata"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Form Metadata</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("editFormFields") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Edit Form Fields", "fa-solid fa-clipboard-list", "editFormFields") }}
                          title={"Edit Form Fields"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Edit Form Fields</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("viewEventSchema") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Event Schema", "fa-solid fa-clipboard-list", "viewEventSchema") }}
                          title={"Event Schema"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Event Schema</span>}
                        </ListGroup.Item>
                      </>
                    )}
                    {(StudyMode === "DV Mode" || StudyMode === "DBP Mode") && (
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("viewFormLists") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Form Lists", "fa-solid fa-clipboard-list", "viewFormLists") }}
                          title={"Form Lists"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Form Lists</span>}
                        </ListGroup.Item>
                      </>
                    )}
                  </div>
                </Collapse>
              </>
            )}
            {(StudyMode === "DV Mode" || StudyMode === "DBP Mode") && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openReport && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenReport(!openReport)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openReport ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Report Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openReport ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openReport === true}>
                  <div>
                    {(StudyMode === "DV Mode" || StudyMode === "DBP Mode") && (
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("viewFormReportLists") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Form Report", "fa-solid fa-clipboard-list", "viewFormReportLists") }}
                          title={"Form Report"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Form Report</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("viewSchemaReportLists") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Schema Report", "fa-solid fa-clipboard-list", "viewSchemaReportLists") }}
                          title={"Schema Report"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Schema Report</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("viewSubjectReportLists") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Subject Report", "fa-solid fa-clipboard-list", "viewSubjectReportLists") }}
                          title={"Subject Report"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Subject Report</span>}
                        </ListGroup.Item>
                      </>
                    )}
                  </div>
                </Collapse>
              </>
            )}
            {(StudyMode === "DBP Mode" || studyPermission?.liveLupReport || studyPermission?.liveSDVLupReport || studyPermission?.qcLupReport || studyPermission?.qcSDVLupReport) && (
              <LupReportingStudySidebar
                studyId={studyId}
                handleAddNewTab={handleAddNewTab}
                checkActiveTab={checkActiveTab}
                checkActiveDynamicTabData={checkActiveDynamicTabData}
                collapseSidebar={collapseSidebar}
                studyPermission={studyPermission}
                studyLabel={studyLabel}
              />
            )}
            {(StudyMode === "DBP Mode" || StudyMode === "SDV Live Mode" || StudyMode === "SDV QC Mode" || studyPermission?.liveDataEntry || studyPermission?.qcDataEntry || studyPermission?.liveReadOnly || studyPermission?.qcReadOnly) && (
              <ListGroup.Item action
                className={`border-0 border-bottom ${checkActiveTab("dataEntry") && "selectedMenu"}`}
                style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => { handleAddNewTab("Data Management", "fa-solid fa-clipboard-list", "dataEntry") }}
                title={"Data Management"}
              >
                <div className="hstack justify-content-between w-100">
                  <span>
                    <i className={`fa-solid fa-clipboard-list me-2`}></i>
                    {!collapseSidebar && <span>Data Management</span>}
                  </span>
                </div>
              </ListGroup.Item>
            )}
            {(StudyMode === "DBP Mode" || (studyPermission?.liveDatasets || studyPermission?.qcDatasets || studyPermission?.liveSDVDatasets || studyPermission?.qcSDVDatasets || studyPermission?.liveDataTransferJob || studyPermission?.liveSDVDataTransferJob || studyPermission?.qcDataTransferJob || studyPermission?.qcSDVDataTransferJob)) && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openDatasets && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenDatasets(!openDatasets)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openDatasets ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Datasets Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openDatasets ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openDatasets === true}>
                  <div>
                    {(StudyMode === "DBP Mode" || (studyPermission?.liveDatasets || studyPermission?.qcDatasets || studyPermission?.liveSDVDatasets || studyPermission?.qcSDVDatasets)) &&
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("subjectStatus") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Subject Status", "fa-solid fa-clipboard-list", "subjectStatus") }}
                          title={"Subject Status"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Subject Status</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("datasets") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Datasets List", "fa-solid fa-clipboard-list", "datasets") }}
                          title={"Datasets List"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Datasets List</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("datasetsByFieldNameLabel") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Datasets Name Label View", "fa-solid fa-clipboard-list", "datasetsByFieldNameLabel") }}
                          title={"Datasets Name Label View"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Datasets Name Label View</span>}
                        </ListGroup.Item>
                      </>
                    }
                    {(StudyMode === "DBP Mode" || (studyPermission?.liveDataTransferJob || studyPermission?.liveSDVDataTransferJob || studyPermission?.qcDataTransferJob || studyPermission?.qcSDVDataTransferJob)) &&
                      <>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("transferedDatasetList") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Transfered Datasets", "fa-solid fa-clipboard-list", "transferedDatasetList") }}
                          title={"Transfered Datasets"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Transfered Datasets</span>}
                        </ListGroup.Item>
                        <ListGroup.Item action
                          className={`border-0 border-bottom ${checkActiveTab("onDemandDatasets") && "selectedMenu"}`}
                          style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                          onClick={() => { handleAddNewTab("Ondemand Datasets", "fa-solid fa-clipboard-list", "onDemandDatasets") }}
                          title={"Ondemand Datasets"}
                        >
                          <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                          {!collapseSidebar && <span>Ondemand Datasets</span>}
                        </ListGroup.Item>
                      </>
                    }
                  </div>
                </Collapse>
              </>
            )}
            {StudyMode !== "DV Mode" && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openQuery && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenQuery(!openQuery)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openQuery ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Query Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openQuery ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openQuery === true}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("manageQuery") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Manage Query", "fa-solid fa-clipboard-list", "manageQuery") }}
                      title={"Manage Query"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Manage Query</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("queryStatistics") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Query Statistics", "fa-solid fa-clipboard-list", "queryStatistics") }}
                      title={"Query Statistics"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Query Statistics</span>}
                    </ListGroup.Item>
                  </div>
                </Collapse>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openNotification && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenNotification(!openNotification)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openNotification ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Notification Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openNotification ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openNotification === true}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("manageNotification") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Manage Notification", "fa-solid fa-clipboard-list", "manageNotification") }}
                      title={"Manage Notification"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Manage Notification</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("notificationStatistics") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Notification Statistics", "fa-solid fa-clipboard-list", "notificationStatistics") }}
                      title={"Notification Statistics"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Notification Statistics</span>}
                    </ListGroup.Item>
                  </div>
                </Collapse>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openSDV && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenSDV(!openSDV)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openSDV ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>SDV Management</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openSDV ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openSDV === true}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("formSDV") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Form SDV", "fa-solid fa-clipboard-list", "formSDV") }}
                      title={"Form SDV"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Form SDV</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("SDVStatistics") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("SDV Statistics", "fa-solid fa-clipboard-list", "SDVStatistics") }}
                      title={"SDV Statistics"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>SDV Statistics</span>}
                    </ListGroup.Item>
                  </div>
                </Collapse>
              </>
            )}
            {StudyMode === "DBP Mode" && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${checkActiveTab("investigatorSignature") && "selectedMenu"}`}
                  style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => { handleAddNewTab("Investigator Signature", "fa-solid fa-clipboard-list", "investigatorSignature") }}
                  title={"Investigator Signature"}
                >
                  <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                  {!collapseSidebar && <span>Investigator Signature</span>}
                </ListGroup.Item>
              </>
            )}
            <ListGroup.Item action
              className={`border-0 border-bottom ${checkActiveTab("labRangeSettings") && "selectedMenu"}`}
              style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "22px"}` }}
              onClick={() => { handleAddNewTab("Lab Range Settings", "fa-solid fa-clipboard-list", "labRangeSettings") }}
              title={"Lab Range Settings"}
            >
              <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
              {!collapseSidebar && <span>Lab Range Settings</span>}
            </ListGroup.Item>
            {StudyMode === "DBP Mode" && (
              <>
                <ListGroup.Item action
                  className={`border-0 border-bottom ${openSettings && "bg-light"}`}
                  style={{ padding: `7px 10px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                  onClick={() => setOpenSettings(!openSettings)}
                >
                  <div className="hstack justify-content-between w-100">
                    <span>
                      <i className={`fa-solid fa-${openSettings ? "folder-open" : "folder"} me-2`}></i>
                      {!collapseSidebar && <span>Study Settings</span>}
                    </span>
                    <span>
                      <i className={`fa-solid fa-angle-${openSettings ? "down" : "right"}`}></i>
                    </span>
                  </div>
                </ListGroup.Item>
                <Collapse in={openSettings === true}>
                  <div>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("customEditChecks") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Custom Edit Checks", "fa-solid fa-clipboard-list", "customEditChecks") }}
                      title={"Custom Edit Checks"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Custom Edit Checks</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("fieldNotificationChecks") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Field Notification Checks", "fa-solid fa-clipboard-list", "fieldNotificationChecks") }}
                      title={"Field Notification Checks"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Field Notification Checks</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("derivedVariable") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Derived Variable", "fa-solid fa-clipboard-list", "derivedVariable") }}
                      title={"Derived Variable"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Derived Variable</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("assignField") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Assign Field", "fa-solid fa-clipboard-list", "assignField") }}
                      title={"Assign Field"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Assign Field</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("assignGender") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Assign Gender", "fa-solid fa-clipboard-list", "assignGender") }}
                      title={"Assign Gender"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Assign Gender</span>}
                    </ListGroup.Item>
                    <ListGroup.Item action
                      className={`border-0 border-bottom ${checkActiveTab("reportMetadata") && "selectedMenu"}`}
                      style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "35px"}` }}
                      onClick={() => { handleAddNewTab("Report Metadata", "fa-solid fa-clipboard-list", "reportMetadata") }}
                      title={"Report Metadata"}
                    >
                      <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                      {!collapseSidebar && <span>Report Metadata</span>}
                    </ListGroup.Item>

                  </div>
                </Collapse>
              </>
            )}
            {studyDocumnetAccess && (
              <ListGroup.Item action
                className={`border-0 border-bottom ${checkActiveTab("studyDocument") && "selectedMenu"}`}
                style={{ padding: `3px 0px 7px ${collapseSidebar ? "15px" : "22px"}` }}
                onClick={() => { handleAddNewTab("Study Document", "fa-solid fa-clipboard-list", "studyDocument") }}
                title={"Study Document"}
              >
                <i className="fa-solid fa-clipboard-list clients me-2" style={{ fontSize: 12 }}></i>
                {!collapseSidebar && <span>Study Document</span>}
              </ListGroup.Item>
            )}
          </ListGroup>
        </ListGroup>
      </div>
    </div>
  );
};

export default StudySidebar;
